import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    tripList: [],
    tripById: {},
    trackData: {},
    loading: {
        tripList: false,
        tripById: false,
        trackData: {},
    },
    error: false,
    errorMessage: "",
};

const RealTimeTripSlice = createSlice({
    name: "realTimeTrip",
    initialState,
    reducers: {
        getTripList(state, action) {
            state.tripList = action.payload;
            state.loading.tripList = false;
            state.error = false;
        },
        getTripById(state, action) {
            state.tripById = action.payload;
            state.loading.tripById = false;
            state.error = false;
        },
        setLoading(state, action) {
            const { key, value, tripId } = action.payload;

            if (key === "trackData" && tripId) {
                state.loading.trackData[tripId] = value;
            } else if (key in state.loading) {
                state.loading[key] = value;
            }
        },
        setTrackData(state, action) {
            const { tripId, data } = action.payload;

            if (tripId) {
                state.trackData = data;
                if (!state.loading.trackData) state.loading.trackData = {};
                state.loading.trackData[tripId] = false;
            }

            state.error = false;
        },
        errorMessages(state, action) {
            state.error = true;
            state.errorMessage = action.payload;
            Object.keys(state.loading).forEach(key => {
                state.loading[key] = false;
            });
        },
        clearError(state) {
            state.error = false;
            state.errorMessage = "";
        },
        clearTripData(state) {
            state.tripList = [];
            state.tripById = {};
        },
    },
});

export const {
    getTripList,
    getTripById,
    setLoading,
    errorMessages,
    clearError,
    clearTripData,
    setTrackData
} = RealTimeTripSlice.actions;

export default RealTimeTripSlice.reducer;
